export default __webpack_public_path__ + "static/media/home3.42834353.jpg";